// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3j7gH","description":"PatientConsentPreview_description__1A2Uu"};